export default {"src":"/_next/static/media/visa.b571a567.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};